import AureusOxLogo from '../../assets/aureus-ox-logo-cmyk-design-300ppi-02.png';
import { AUREUS_OX_URL } from '../../constants/links';

const AUREUS = {
  green: '#6FC2AE',
  blue: '#609EBD',
  navy: '#01263D',
  purple: '#4643D3'
};

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer
      className="py-12 border-t text-center"
      style={{
        background: AUREUS.navy,
        borderColor: 'rgba(96, 158, 189, 0.15)'
      }}
    >
      <div className="mx-auto max-w-6xl px-6">
        {/* Top row: Links */}
        <div className="flex flex-wrap justify-center gap-8 md:gap-12 mb-8 text-sm opacity-90">
          <a
            href="/support"
            className="hover:text-white transition-colors"
            style={{ color: AUREUS.blue }}
          >
            FAQ / Help
          </a>
          <a
            href="/#how-it-works"
            className="hover:text-white transition-colors"
            style={{ color: AUREUS.blue }}
          >
            How it works
          </a>
          <a
            href="https://public.oxenflow.io/legal/privacy_policy.html"
            className="hover:text-white transition-colors"
            style={{ color: AUREUS.blue }}
          >
            Privacy Policy
          </a>
          <a
            href="https://public.oxenflow.io/legal/terms_of_service.html"
            className="hover:text-white transition-colors"
            style={{ color: AUREUS.blue }}
          >
            Terms of Service
          </a>
          <a
            href="mailto:info@oxenflow.io"
            className="hover:text-white transition-colors"
            style={{ color: AUREUS.blue }}
          >
            Contact Us
          </a>
        </div>

        {/* Social Icons Row — Oxen Flow product channels */}
        <div className="flex justify-center gap-10 mb-10">
          <a
            href="https://x.com/OxenFlow"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:opacity-80 transition-opacity"
            aria-label="Oxen Flow on X"
          >
            <svg className="h-7 w-7" fill="currentColor" viewBox="0 0 24 24">
              <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
            </svg>
          </a>

          <a
            href="https://www.youtube.com/channel/UCvkBsqQn_1efXcyLXecvnkQ"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:opacity-80 transition-opacity"
            aria-label="Oxen Flow on YouTube"
          >
            <svg className="h-7 w-7" fill="currentColor" viewBox="0 0 24 24">
              <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.235 0-3.897.266-4.356 2.62-4.357 8.122v1.388c.001 5.502.46 7.856 4.357 8.122 3.604.246 11.631.245 15.235 0 3.897-.266 4.356-2.62 4.357-8.122v-1.388c0-5.502-.46-7.856-4.357-8.122zM9.846 15.867V8.133L15.615 12l-5.769 3.867z" />
            </svg>
          </a>
        </div>

        {/* Built & curated by Aureus Ox */}
        <div
          className="mb-8 pt-8 border-t"
          style={{ borderColor: 'rgba(96, 158, 189, 0.15)' }}
        >
          <p
            className="text-xs uppercase tracking-[0.2em] mb-4 opacity-70"
            style={{ color: AUREUS.blue }}
          >
            Built &amp; curated by
          </p>
          <a
            href={AUREUS_OX_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex flex-col items-center gap-3 group"
          >
            <div className="relative">
              <div
                className="absolute -inset-3 rounded-2xl blur opacity-25 group-hover:opacity-40 transition-opacity"
                style={{
                  background: `linear-gradient(90deg, ${AUREUS.green}, ${AUREUS.blue}, ${AUREUS.purple})`
                }}
              />
              <img
                src={AureusOxLogo}
                alt="Aureus Ox"
                className="relative w-36 md:w-40"
              />
            </div>
            <span
              className="text-sm opacity-80 group-hover:opacity-100 transition-opacity"
              style={{ color: AUREUS.green }}
            >
              aureusox.com
            </span>
          </a>
          <p className="mt-3 text-sm opacity-60 max-w-md mx-auto">
            Flare &amp; XRPL infrastructure · operator-built product
          </p>
          <a
            href="https://x.com/AureusOx"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block mt-2 text-sm hover:text-white transition-colors opacity-80 hover:opacity-100"
            style={{ color: AUREUS.blue }}
          >
            @AureusOx
          </a>
        </div>

        {/* Bottom copyright + disclaimer */}
        <div className="text-sm opacity-70">
          <p>
            © {year} Oxen Flow · Built by Aureus Ox · Built for Flare Network
          </p>
          <p className="mt-2">
            Non-custodial · Your keys, your crypto · info@oxenflow.io
          </p>
          <p className="mt-4 text-xs opacity-60 max-w-2xl mx-auto leading-relaxed">
            Oxen Flow is non-custodial software. Nothing on this site is
            financial, investment, or legal advice. Blockchain network fees may
            apply. Use at your own risk.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
